module.exports = __webpack_public_path__ + "img/560a88b.png";